module.exports = __webpack_public_path__ + "img/DOJOLOGO_BLACK.c011815d.png";